import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: "calc(var(--fs-xl)*1.886792)",
    height: "calc(var(--fs-xs)*1.886792)",
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: "calc(var(--sp-xxs)*0.47169)",
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(calc(var(--sp-lg)*1.037735))',
            color: '#fff',
            '& + .MuiSwitch-track': {
            backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#F8B218',
            opacity: 1,
            border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: 'calc(var(--sp-sm)*1) solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
            theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: "calc(var(--fs-xs)*1.509434)",
        height: "calc(var(--fs-xs)*1.509434)",
    },
    '& .MuiSwitch-track': {
        borderRadius: "calc(var(--sp-md2)*1)",
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

export default IOSSwitch